import { render, staticRenderFns } from "./DefectDescriptions.vue?vue&type=template&id=32c3ca16&scoped=true"
import script from "./DefectDescriptions.vue?vue&type=script&lang=js"
export * from "./DefectDescriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c3ca16",
  null
  
)

export default component.exports